import { tgfGraphics } from "../framework/tgfGraphics";
import { PIXI } from "./tbPIXI";
import { tbImage } from "./tbImage";
import { tbSpine } from "./tbSpine";
import { tbSpriteAnimation } from "./tbSpriteAnimation";
import { tbVectorFont } from "./tbVectorFont";
export var tbTiling = function (sprite, width, height) {
    "use strict";
    this.x = 0;
    this.y = 0;
    this.offsetX = 0;
    this.offsetY = 0;
    this.scaleX = 1;
    this.scaleY = 1;
    this.alpha = 1;
    this.width = width;
    this.height = height;
    this.sprite = new PIXI["extras"]["TilingSprite"](sprite, this.width, this.height);
};
tbTiling.prototype.setPosition = function (x, y) {
    "use strict";
    this.x = x;
    this.y = y;
    if (this.sprite && !this.sprite["_destroyed"]) {
        this.sprite["x"] = this.x;
        this.sprite["y"] = this.y;
    }
};
tbTiling.prototype.setScale = function (x, y) {
    "use strict";
    this.scaleX = x;
    this.scaleY = y;
    if (this.sprite && !this.sprite["_destroyed"]) {
        this.sprite["tileScale"]["x"] = this.scaleX;
        this.sprite["tileScale"]["y"] = this.scaleY;
    }
};
tbTiling.prototype.setDimensions = function (w, h) {
    "use strict";
    this.width = w;
    this.height = h;
    if (this.sprite && !this.sprite["_destroyed"]) {
        this.sprite["width"] = this.width;
        this.sprite["height"] = this.height;
    }
};
tbTiling.prototype.setOffset = function (x, y) {
    "use strict";
    this.offsetX = x;
    this.offsetY = y;
    if (this.sprite && !this.sprite["_destroyed"]) {
        this.sprite["tilePosition"]["x"] = this.offsetX;
        this.sprite["tilePosition"]["y"] = this.offsetY;
    }
};
tbTiling.prototype.setAlpha = function (alpha) {
    "use strict";
    this.alpha = alpha;
    if (this.alpha > 1) {
        this.alpha = 1;
    }
    else if (this.alpha < 0) {
        this.alpha = 0;
    }
    this.sprite["alpha"] = this.alpha;
};
tbTiling.prototype.addChild = function (obj) {
    "use strict";
    var _obj;
    if (obj instanceof tbImage) {
        if (obj.sprite) {
            _obj = obj.sprite;
        }
    }
    else if (obj instanceof tbSpine) {
        if (obj.animation) {
            _obj = obj.animation;
        }
    }
    else if (obj instanceof tbVectorFont) {
        if (obj.font) {
            _obj = obj.font;
        }
    }
    else if (obj instanceof tbSpriteAnimation) {
        if (obj.animation) {
            _obj = obj.animation;
        }
    }
    else {
        _obj = obj;
    }
    if (_obj) {
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["addChild"](_obj);
        }
    }
};
tbTiling.prototype.removeChild = function (obj) {
    "use strict";
    var _obj;
    if (obj instanceof tbImage) {
        if (obj.sprite) {
            _obj = obj.sprite;
        }
    }
    else if (obj instanceof tbSpine) {
        if (obj.animation) {
            _obj = obj.animation;
        }
    }
    else if (obj instanceof tbVectorFont) {
        if (obj.font) {
            _obj = obj.font;
        }
    }
    else if (obj instanceof tbSpriteAnimation) {
        if (obj.animation) {
            _obj = obj.animation;
        }
    }
    else {
        _obj = obj;
    }
    if (_obj) {
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["removeChild"](_obj);
        }
    }
};
tbTiling.prototype.add = function (container) {
    "use strict";
    var obj;
    if (this.sprite && !this.sprite["_destroyed"]) {
        obj = this.sprite;
    }
    if (obj) {
        if (container && container["addChild"]) {
            container["addChild"](obj);
        }
        else {
            tgfGraphics.addChild(obj);
        }
    }
};
tbTiling.prototype.remove = function (container) {
    "use strict";
    var obj;
    if (this.sprite && !this.sprite["_destroyed"]) {
        obj = this.sprite;
    }
    if (obj) {
        if (container && container["removeChild"]) {
            container["removeChild"](obj);
        }
        else {
            tgfGraphics.removeChild(obj);
        }
    }
};
tbTiling.prototype.free = function (alsoChildren) {
    "use strict";
    if (typeof alsoChildren === "undefined") {
        alsoChildren = true;
    }
    var options = { "children": alsoChildren,
        "texture": false,
        "baseTexture": false };
    if (this.sprite && !this.sprite["_destroyed"]) {
        this.sprite["destroy"](options);
        this.sprite = null;
    }
};
tbTiling.prototype.setTint = function (tint) {
    "use strict";
    if (this.sprite && tint) {
        this.sprite["tint"] = tint;
    }
};
tbTiling.prototype.setMask = function (mask) {
    "use strict";
    if (this.sprite && mask) {
        this.sprite["mask"] = mask;
    }
};
tbTiling.prototype.setBlur = function (value) {
    "use strict";
    var _value = value ? value : 0;
    if (this.sprite && !this.sprite["_destroyed"]) {
        var filter = new PIXI["filters"]["BlurFilter"]();
        filter["blur"] = _value;
        this.sprite["filters"] = [filter];
    }
};
